module.exports = __webpack_public_path__ + "img/05-26-166.0300263a.png";